/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_Note_None_PlainInputs */

const en_us2_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No soreness today. Your workout goes ahead as planned.`)
};

const pt_br2_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dor hoje. Seu treino segue como planejado.`)
};

const es_419_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin dolor hoy. Tu entrenamiento sigue según lo planeado.`)
};

const pt_pt2_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dor hoje. O teu treino segue como planeado.`)
};

const fr_fr2_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de courbatures aujourd'hui. Ta séance se déroule comme prévu.`)
};

const de_de2_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute kein Muskelkater. Dein Training läuft wie geplant.`)
};

const it_it2_today_checkin_note_none_plain = /** @type {(inputs: Today_Checkin_Note_None_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dolore oggi. Il tuo allenamento procede come previsto.`)
};

/**
* | output |
* | --- |
* | "No soreness today. Your workout goes ahead as planned." |
*
* @param {Today_Checkin_Note_None_PlainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_note_none_plain = /** @type {((inputs?: Today_Checkin_Note_None_PlainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_Note_None_PlainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_note_none_plain(inputs)
	if (locale === "es-419") return es_419_today_checkin_note_none_plain(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_note_none_plain(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_note_none_plain(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_note_none_plain(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_note_none_plain(inputs)
	return en_us2_today_checkin_note_none_plain(inputs)
});
export { today_checkin_note_none_plain as "today.checkin_note_none_plain" }